export default "__VITE_ASSET__CUFAB4yV__"